'use strict';

const squadSearch = {
  namespaced: true,
  state: {
    joining: false,
    joined: false,
    squad: {
      name: ""
    }
  },
  mutations: {
    setJoining(state, bool) {
      state.joining = bool;
    },

    setJoined(state, bool) {
      state.joined = bool;
    },

    setSquad(state, obj) {
      state.squad = obj;
    }
  }
};

export default squadSearch;



// WEBPACK FOOTER //
// ./app/javascript/vue/vuex/modules/squad-search.js